// @ts-nocheck
/* eslint-disable */
export default function createBarChart(
  dataArr,
  ordinate = '纵坐标',
  abscissa = '横坐标'
) {
  var canvas, ctx

  var cWidth, cHeight, cMargin, cSpace
  var originX, originY

  var bMargin, tobalBars, bWidth, maxValue
  var totalYNomber
  var gradient

  var ctr, numctr, speed
  var mousePosition = {}

  canvas = document.getElementById('barChart')
  if (canvas && canvas.getContext) {
    ctx = canvas.getContext('2d')
  }
  initChart()
  drawLineLabelMarkers()
  drawBarAnimate()
  var mouseTimer = null
  canvas.addEventListener('mousemove', function(e) {
    e = e || window.event
    if (e.layerX || e.layerX == 0) {
      mousePosition.x = e.layerX
      mousePosition.y = e.layerY
    } else if (e.offsetX || e.offsetX == 0) {
      mousePosition.x = e.offsetX
      mousePosition.y = e.offsetY
    }

    clearTimeout(mouseTimer)
    mouseTimer = setTimeout(function() {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      drawLineLabelMarkers()
      drawBarAnimate(true)
    }, 10)
  })

  canvas.onclick = function() {
    initChart()
    drawLineLabelMarkers()
    drawBarAnimate()
  }

  function initChart() {
    cMargin = 30
    cSpace = 60
    cHeight = canvas.height - cMargin * 2 - cSpace
    cWidth = canvas.width - cMargin * 2 - cSpace
    originX = cMargin + cSpace
    originY = cMargin + cHeight

    bMargin = 15
    tobalBars = dataArr.length
    bWidth = parseInt(cWidth / tobalBars - bMargin)
    maxValue = 0
    for (var i = 0; i < dataArr.length; i++) {
      var barVal = parseInt(dataArr[i][1])
      if (barVal > maxValue) {
        maxValue = barVal
      }
    }
    maxValue += 50
    totalYNomber = 10

    ctr = 1
    numctr = 100
    speed = 10

    gradient = ctx.createLinearGradient(0, 0, 0, 300)
    gradient.addColorStop(0, '#AD3C30')
    gradient.addColorStop(1, '#AD3C30')
  }

  function drawLineLabelMarkers() {
    ctx.translate(0.5, 0.5)
    ctx.font = '12px Arial'
    ctx.lineWidth = 1
    ctx.fillStyle = '#000'
    ctx.strokeStyle = '#000'

    drawLine(originX, originY, originX, cMargin)

    drawLine(originX, originY, originX + cWidth, originY)

    drawMarkers()
    ctx.translate(-0.5, -0.5)
  }

  function drawLine(x, y, X, Y) {
    ctx.beginPath()
    ctx.moveTo(x, y)
    ctx.lineTo(X, Y)
    ctx.stroke()
    ctx.closePath()
  }

  function drawMarkers() {
    ctx.strokeStyle = '#E0E0E0'

    var oneVal = parseInt(maxValue / totalYNomber)
    ctx.textAlign = 'right'
    for (var i = 0; i <= totalYNomber; i++) {
      var markerVal = i * oneVal
      var xMarker = originX - 5
      var yMarker = parseInt(cHeight * (1 - markerVal / maxValue)) + cMargin
      ctx.fillText(markerVal, xMarker, yMarker + 3, cSpace)
      if (i > 0) {
        drawLine(originX, yMarker, originX + cWidth, yMarker)
      }
    }

    ctx.textAlign = 'center'
    for (var i = 0; i < tobalBars; i++) {
      var markerVal = dataArr[i][0]
      var xMarker = parseInt(
        originX + cWidth * (i / tobalBars) + bMargin + bWidth / 2
      )
      var yMarker = originY + 15
      ctx.fillText(markerVal, xMarker, yMarker, cSpace)
    }

    ctx.save()
    ctx.rotate(-Math.PI / 2)
    ctx.fillText(ordinate, -canvas.height / 2, cSpace - 10)
    ctx.restore()

    ctx.fillText(abscissa, originX + cWidth / 2, originY + cSpace / 2 + 10)
  }

  function drawBarAnimate(mouseMove) {
    for (var i = 0; i < tobalBars; i++) {
      var oneVal = parseInt(maxValue / totalYNomber)
      var barVal = dataArr[i][1]
      var barH = parseInt((((cHeight * barVal) / maxValue) * ctr) / numctr)
      var y = originY - barH
      var x = originX + (bWidth + bMargin) * i + bMargin
      drawRect(x, y, bWidth, barH, mouseMove)
      ctx.fillText(parseInt((barVal * ctr) / numctr), x + 15, y - 8)
    }
    if (ctr < numctr) {
      ctr++
      setTimeout(function() {
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        drawLineLabelMarkers()
        drawBarAnimate()
      }, speed)
    }
  }

  function drawRect(x, y, X, Y, mouseMove) {
    ctx.beginPath()
    ctx.rect(x, y, X, Y)
    if (mouseMove && ctx.isPointInPath(mousePosition.x, mousePosition.y)) {
      ctx.fillStyle = '#AD3C30'
    } else {
      ctx.fillStyle = gradient
      ctx.strokeStyle = gradient
    }
    ctx.fill()
    ctx.closePath()
  }
}
